import { DownloadIcon } from '@chakra-ui/icons'
import { Box, Center, Flex, Image, Stack, Text, VStack } from '@chakra-ui/react'
import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import flagIcon from 'src/asset/images/flag.svg'
import useSubscription from 'src/hooks/useSubscription'
import { useUser } from 'src/hooks/useUser'
import {
  GetVideoDetails,
  SetLessonExercises,
  SetLessonExercisesProgress,
  SetLessonVideo,
  SetLessonVocabularies
} from 'src/redux/actions'

import { downloadFile } from '../../util/helpers'
import VideoPlayer from '../4lPlayer'
import MediaSharePanel from '../MediaSharePanel'
import ReportSection from '../ReportSection'
import NoRecordFound from './NoRecordFound'
import { isMobile } from './Practice/Util'
import Unsubscribed from './Unsubscribed'
import LoadingOverlay from 'src/util/hoc/LoadingOverlay'
import CardLoader from '../CardLoader'

const ShareReportOptions = ({ selectedLesson, setOpen }) => {
  return (
    <VStack style={{ position: 'fixed', top: '110px', marginRight: '10px' }}>
      <Image
        src={flagIcon}
        alt="Report Issue Langistan"
        boxSize="25px"
        onClick={setOpen}
        cursor={'pointer'}
        className='iconHover'
      ></Image>

      {selectedLesson?.lesson?.isUnLock && <MediaSharePanel showText={false}></MediaSharePanel>}
      {selectedLesson?.lesson?.file && <DownloadIcon className='iconHover' cursor='pointer' name='lesson-info-download-icon' alt='Download lesson file' onClick={() => downloadFile(selectedLesson?.lesson?.file)} />}
    </VStack>
  )
}

const LearnTab = ({ onLearnVideoEnd, setProgress, playingProps, playerRef }) => {
  const dispatch = useDispatch()
  const params = useParams()
  const { isSubscriptionActive, hasLangSubscription } = useSubscription(
    params.courseId
  )
  const { loading: userLoading, user: auth } = useUser()

  const {
    videoDetails,
    selectedLesson,
    selectedLanguage,
    loading,
    loadingCourse,
  } = useSelector(store => store.mainReducer)

  const [open, setOpen] = useState(false);

  const currentVideoId = useMemo(() => {
    return selectedLesson?.lesson?.video
      || selectedLesson?.lesson?.fourLVideo;
  }, [selectedLesson?.lesson?.video, selectedLesson?.lesson?.fourLVideo, selectedLesson?.lesson?.videoType]);

  useEffect(() => {
    dispatch(SetLessonExercises([]))
    dispatch(SetLessonExercisesProgress({}))
    return () => {
      dispatch(SetLessonVocabularies([])) && dispatch(SetLessonVideo({}))
    }
  }, [dispatch])

  useEffect(() => {
    if (currentVideoId) {
      dispatch(GetVideoDetails(currentVideoId))
    }
    return () => {
      // Only clear if we're actually changing videos
      if (currentVideoId) {
        dispatch(SetLessonVideo({}))
      }
    }
  }, [currentVideoId, dispatch, selectedLesson?.lesson])
  if (loadingCourse || loading) return <Center height="60vh" p={6} textAlign="center"><CardLoader height='426px' maxW='620px' /></Center>
  if (loading || loadingCourse) {
    return ''
  }
  if (!selectedLesson?.lesson?.video && !videoDetails?.video) {
    return <NoRecordFound textToDisplay="Video" descriptionText="This lesson doesn't contain a video component. Check back later or explore other lessons." />
  }
  if (
    !(
      selectedLesson &&
      selectedLesson.lesson &&
      (selectedLesson.lesson.video ||
        selectedLesson.lesson.fourLVideo)
    ) &&
    !loading &&
    !loadingCourse
  ) {
    return <NoRecordFound textToDisplay="Video" descriptionText="This lesson doesn't contain a video component. Check back later or explore other lessons." />
  }
  if (
    !loading &&
    !selectedLesson?.lesson?.isUnLock &&
    !hasLangSubscription(selectedLanguage) &&
    auth.role !== 'ADMIN' &&
    !auth.isStarUser && (selectedLanguage.product !== 'free_product')
  ) {
    return <Unsubscribed />
  } return (
    <>
      <Stack className="introduction-content">


        <>
          <Box paddingTop={['10px', '10px', '10px']}>
            <div className="video-player_wrapper">
              <VideoPlayer
                videoSrc={videoDetails?.video || selectedLesson?.lesson?.video}
                // videoSrc={videoDetails.video}
                subtitles={videoDetails?.subtitle}
                setProgress={setProgress}
                ref={playerRef}
                {...playingProps}
              />
            </div>

            <VStack alignItems={'flex-end'}>
              {!isMobile && <ShareReportOptions selectedLesson={selectedLesson} setOpen={setOpen} />}
              {isMobile && (
                <VStack className='share-panel-mobile' display='none'>
                  <Box p={10} w={'full'}>
                    <Flex
                      justifyContent={'flex-end'}
                      alignItems={'center'}
                      w={'100%'}
                    >
                      <Image
                        src={flagIcon}
                        alt="Report Issue Langistan"
                        boxSize="25px"
                        onClick={setOpen}
                        cursor={'pointer'}
                        mr={'30px'}
                      ></Image>

                      <MediaSharePanel showText={false}></MediaSharePanel>
                    </Flex>
                  </Box>
                </VStack>
              )}
            </VStack>
          </Box>
        </>

        {open && <ReportSection open={open} setOpen={setOpen}></ReportSection>}
      </Stack>
    </>
  )
}

export default React.memo(LearnTab)